import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllCluster = async (params: any) => {
  const url = endpoints.CLUSTER;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getClusterById = async (id: number) => {
  const url = endpoints.CLUSTER + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createCluster = async (params: any) => {
  const url = endpoints.CLUSTER;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateCluster = async (params: any) => {
  const url = endpoints.CLUSTER + "/" + params.id;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteCluster = async (id: number) => {
  const url = endpoints.CLUSTER + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getAllNearbyByClusterId = async (id: number) => {
  const url = endpoints.CLUSTER + `/${id}/nearby`;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getNearbyById = async (id: number) => {
  const url = endpoints.CLUSTER + `/nearby/${id}`;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createNearby = async (params: any) => {
  const url = endpoints.CLUSTER + "/nearby";

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateNearby = async (params: any) => {
  const url = endpoints.CLUSTER + "/nearby/" + params.id;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteNearby = async (id: number) => {
  const url = endpoints.CLUSTER + "/nearby/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const clusterService = {
  getAllCluster,
  createCluster,
  updateCluster,
  deleteCluster,
  getClusterById,
  getAllNearbyByClusterId,
  getNearbyById,
  updateNearby,
  deleteNearby,
  createNearby,
};

export default clusterService;
